/**
 *
 * ShutdownBanner
 *
 */

import React from 'react';

import { useDataContext } from 'utils/context';
import { exportAllData } from 'utils/exportData';

import './ShutdownBanner.css';

function ShutdownBanner() {
  const data = useDataContext();
  const dataAvailable = !!(data.hasData && data.hasData());

  return (
    <div className="shutdown-banner">
      <i className="fa fa-exclamation-triangle" />
      <p>
        Eclipse Manager is shutting down and will no longer be available after <strong>September 30, 2026</strong>.
      </p>
      { dataAvailable && (
        <button
          type="button"
          className="shutdown-banner-export"
          onClick={() => exportAllData(data)}
        >
          Export My Data
        </button>
      )}
    </div>
  );
}

export default ShutdownBanner;
